import { useState } from 'react'
import { useLanguage } from '@/i18n/LanguageContext'
import { SectionHeading } from '@/components/ui/SectionHeading'
import { PORTFOLIO_PROJECTS } from '@/lib/portfolio'
import { ProjectFolder } from './ProjectFolder'
import { Lightbox } from './Lightbox'

/** #portfolio — Phase 4. Real Tehnostan + MM Metal projects, Stitch editorial presentation. */
export function PortfolioSection() {
  const { t } = useLanguage()
  const [lightbox, setLightbox] = useState<{ image: string; alt: string } | null>(null)

  return (
    <section id="portfolio" className="px-6 py-section-gap md:px-margin-desktop">
      <div className="mx-auto flex max-w-container flex-col gap-10">
        <SectionHeading title={t('portfolio-title')} subtitle={t('portfolio-sub')} />

        <div className="flex flex-col gap-16 md:gap-24">
          {PORTFOLIO_PROJECTS.map((project, i) => (
            <ProjectFolder
              key={project.id}
              project={project}
              reverse={i % 2 === 1}
              onAssetClick={(image, alt) => setLightbox({ image, alt })}
            />
          ))}
        </div>
      </div>

      <Lightbox image={lightbox?.image ?? null} alt={lightbox?.alt ?? ''} onClose={() => setLightbox(null)} />
    </section>
  )
}
